import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hazards-container',
  templateUrl: './hazards-container.component.html',
  styleUrls: ['./hazards-container.component.scss']
})
export class HazardsContainerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
